import React from "react";
import { Link } from "react-router-dom";
import { Collapse } from 'antd';

import Icons from "components/icons";
import { useCheckSet } from "components/use-hooks";

const { Panel } = Collapse;


const CompanyPageStep = ({ closeDrawer, showroom, ...props}) => {

    const checkSet = useCheckSet(showroom);
    const checkResult = companyStepCheck({ ...checkSet });

    return(
        <Panel
            { ...props }
            header={
                <>
                    <p className={`sub-text${ checkResult.blockFinish ? "-success" : "" }`}>
                        { checkResult.blockFinish ? "Done" : `${ checkResult.stepsLeft } steps left`}
                    </p>
                    <h5>Company page</h5>
                </>
            }
            key="company-page"
        >
            <div className={ `step ${ checkResult.pageBanner ? "done" : "" }` }>
                <div className="success-badge">
                    <Icons.Check />
                </div>
                <div className="description">
                    <h6>Add page banner</h6>
                    <p className="sub-text">
                        This is the first image people see on the Page.
                    </p>
                    <Link
                        onClick={ closeDrawer }
                        className="link-button second"
                        to="/showroom-configurator/company"
                    >
                        Add photo
                    </Link>
                </div>
            </div>
            <div className={ `step ${ checkResult.companyDescription ? "done" : "" }` }>
                <div className="success-badge">
                    <Icons.Check />
                </div>
                <div className="description">
                    <h6>Add text about the company</h6>
                    <p className="sub-text">
                        Tell users about your company and its strengths.
                    </p>
                    <Link
                        onClick={ closeDrawer }
                        className="link-button second"
                        to="/showroom-configurator/company"
                    >
                        Add text
                    </Link>
                </div>
            </div>
        </Panel>
    );
};

export const companyStepCheck = ({ meta } = {}) => {

    let checkResult = {
        stepAmount: 2,
        stepFinish: 0,
        stepsLeft: 0,
        blockFinish: false,
        pageBanner : false,
        companyDescription : false,
    };

    if(!meta){
        return false;
    }

    if(meta.getValue( meta.fields, "about_description" )){
        checkResult.stepFinish++;
        checkResult.companyDescription = true;
    }

    if(meta.getValue( meta.fields, "company_image_1" )){
        checkResult.stepFinish++;
        checkResult.pageBanner = true;
    }

    checkResult.blockFinish = checkResult.stepAmount === checkResult.stepFinish;
    checkResult.stepsLeft = checkResult.stepAmount - checkResult.stepFinish;

    return checkResult;
}

export default CompanyPageStep;